import { render, staticRenderFns } from "./Imagefield.vue?vue&type=template&id=a2e12a42&scoped=true&"
import script from "./Imagefield.vue?vue&type=script&lang=js&"
export * from "./Imagefield.vue?vue&type=script&lang=js&"
import style0 from "./Imagefield.vue?vue&type=style&index=0&id=a2e12a42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e12a42",
  null
  
)

export default component.exports